import {format, isWithinInterval} from 'date-fns';
import {FORMATS} from '../../constants';
import {PtrnCampoEditableDatetime, PtrnCampoValidarResult} from '../../patronTypes';
import {PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg} from './ptrnProcesarUtils';
import {ValidateState} from 'lib.common';

export const ptrnValidarDatetime: PtrnValidarCampoFn<Date | null, PtrnCampoEditableDatetime> = (
   currValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();

   if (currValue) {
      // 1. Control de errores que deben evitar actualización
      if (campoConfig.maxDate && campoConfig.minDate && currValue) {
         const maxDateTime = new Date(campoConfig.maxDate);
         maxDateTime.setHours(23, 59, 59, 999);

         const minDateTime = new Date(campoConfig.minDate);
         minDateTime.setHours(0, 0, 0, 0);

         if (!isWithinInterval(currValue, {start: minDateTime, end: maxDateTime})) {
            validateResult.errores.push(
               PtrnProcesarUtilsCfg.ErrValidar(
                  `La fecha y hora debe estar entre ${format(
                     minDateTime,
                     FORMATS.datetime
                  )} y ${format(maxDateTime, FORMATS.datetime)}`
               )
            );
            validateResult.gravedadMaxima = ValidateState.ERROR;
            return validateResult;
         }
      } else {
         if (campoConfig.maxDate && currValue) {
            const maxDateTime = new Date(campoConfig.maxDate);
            maxDateTime.setHours(23, 59, 59, 999);
            if (currValue > maxDateTime) {
               validateResult.errores.push(
                  PtrnProcesarUtilsCfg.ErrValidar(
                     `La fecha y hora no puede ser posterior a ${format(
                        maxDateTime,
                        FORMATS.datetime
                     )}`
                  )
               );
               validateResult.gravedadMaxima = ValidateState.ERROR;
               return validateResult;
            }
         }

         if (campoConfig.minDate && currValue) {
            const minDateTime = new Date(campoConfig.minDate);
            minDateTime.setHours(0, 0, 0, 0);
            if (currValue < minDateTime) {
               validateResult.errores.push(
                  PtrnProcesarUtilsCfg.ErrValidar(
                     `La fecha y hora no puede ser anterior a ${format(
                        minDateTime,
                        FORMATS.datetime
                     )}`
                  )
               );
               validateResult.gravedadMaxima = ValidateState.ERROR;
               return validateResult;
            }
         }
      }

      if (campoConfig.disableWeekends && [0, 6].includes(currValue.getDay())) {
         validateResult.errores.push(
            PtrnProcesarUtilsCfg.ErrValidar('No se permiten fechas en fin de semana')
         );
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }

      if (campoConfig.disabledDays?.includes(currValue.getDay())) {
         validateResult.errores.push(PtrnProcesarUtilsCfg.ErrValidar('Día no permitido'));
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }

      if (
         campoConfig.excludeDates?.some((date) => {
            const excludeDate = new Date(date);
            return (
               excludeDate.getFullYear() === currValue.getFullYear() &&
               excludeDate.getMonth() === currValue.getMonth() &&
               excludeDate.getDate() === currValue.getDate()
            );
         })
      ) {
         validateResult.errores.push(PtrnProcesarUtilsCfg.ErrValidar('Fecha no permitida'));
         validateResult.gravedadMaxima = ValidateState.ERROR;
         return validateResult;
      }
   }

   return validateResult;
};
